import Vue from 'vue';
import Vuelidate from 'vuelidate';
import * as VueGoogleMaps from 'vue2-google-maps';
import quickscan from './modules/quickscan/components/quickscan.vue';
import dealermodule from './modules/dealermodule/components/dealermodule.vue';
import Settings from './models/settings.js';
import GmapCluster from 'vue2-google-maps/src/components/cluster';
import VueRouter from 'vue-router';

Vue.use(Vuelidate);

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAafUDEx3U3wRwHbtR-ZQU_le6dNndaa1k',
        libraries: 'places'
    },
    installComponents: true
});

Vue.component('GmapCluster', GmapCluster);

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history'
});


function init() {
    var objSettings = new Settings(window.settings || {});

    var elQuickscan = document.querySelector('.vue-quickscan');
    if (elQuickscan !== null) {
        new Vue({
            el: '.vue-quickscan',
            render: h => h(
                quickscan,
                {
                    props: {
                        settings: objSettings
                    }
                }
            )
        });
    }

    var elDealerModule = document.querySelector('.vue-dealermodule');
    if (elDealerModule !== null) {
        new Vue({
            el: '.vue-dealermodule',
            render: h => h(
                dealermodule,
                {
                    props: {
                        settings: objSettings
                    }
                }
            ),
            router
        });
    }
}

export default {
    init
};
